import type { ProductInterface } from '~/modules/GraphQL/types';
import { ROOT_BIKE_CATEGORY } from '~/helpers/routes';

export const isBikeProduct = (product: ProductInterface) => product.categories?.some((category) => category.url_path === ROOT_BIKE_CATEGORY);
